import {
    AimsStatus,
    CheckPolicyValidityResponse,
    PolicyFlag,
    GeneratePolicyOnCreditResponse,
    GetAllPoliciesResponse,
    GetPolicyByQuoteNumberResponse,
    GetPolicyDocResponse,
    GetPolicyResponse,
    MpesaPaymentRequest,
    MpesaPaymentResponse,
    PushToAmisResponse,
    GetSinglePolicyByQuoteNumberResponse,
    DependantsResponse,
    GetPolicyUploadedDocResponse,
    MpesaOfflinePaymentDetailsResponse,
    ValidateMpesaOfflinePaymentRequest,
    ValidateMpesaOfflinePaymentResponse,
    CanclePolicyResponse,
    DownloadPolicyReportResponse,
    MTNPaymentRequest,
    MTNPaymentResponse,
    GetMTNPaymentStatusResponse
} from 'Application/models';
import { APICallInstance } from './APICallInstance';
import { AxiosResponse } from 'axios';
import dayjs from 'dayjs';
import { CanclePolicyRequest } from 'Application/models/dto/request/PolicyRequest';

class PolicyServiceClass {
    generatePolicyOnCredit = async (quoteNumber: string) => {
        const url = `/api/v1/policy/generate-credit?quoteNumber=${quoteNumber}`;

        try {
            const response: AxiosResponse<GeneratePolicyOnCreditResponse> = await APICallInstance.post(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    generatePolicyOnMpesa = async (MpesaPayment: MpesaPaymentRequest) => {
        const url = `/api/v1/payment/handle-stk`;

        try {
            const response: AxiosResponse<MpesaPaymentResponse> = await APICallInstance.post(url, MpesaPayment);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    generatePolicyOnMTN = async (MtnPayment: MTNPaymentRequest) => {
        const url = `/api/v1/payment/mtn-stk`;

        try {
            const response: AxiosResponse<MTNPaymentResponse> = await APICallInstance.post(url, MtnPayment);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    generatePolicyOnMpesaOffline = async (quoteNumber: string, validatePaymentDetails: ValidateMpesaOfflinePaymentRequest) => {
        const url = `/api/v1/payment/validate?quotationNumber=${quoteNumber}`;

        try {
            const response: AxiosResponse<ValidateMpesaOfflinePaymentResponse> = await APICallInstance.post(url, validatePaymentDetails);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getPolicyDocument = async (policyNumber: string) => {
        const url = '/api/v1/policy/download';

        try {
            const response: AxiosResponse<GetPolicyDocResponse> = await APICallInstance.get(url, {
                params: {
                    policyNumber: policyNumber
                },
                responseType: 'blob'
            });
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    getPolicyUpladedFiles = async (fileName: string) => {
        const url = '/api/v1/file';

        try {
            const response: AxiosResponse<GetPolicyUploadedDocResponse> = await APICallInstance.get(url, {
                params: {
                    fileName: fileName
                },
                responseType: 'blob'
            });
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    fetchPolicy = async (agencyName: string, page: number, pageSize: number, startDate?: string, endDate?: string) => {
        const url = 'api/v1/agency/policies';

        try {
            const response: AxiosResponse<GetPolicyResponse> = await APICallInstance.get(url, {
                params: {
                    agencyName: agencyName,
                    page: page,
                    pageSize: pageSize,
                    ...(startDate ? { startDate: dayjs(startDate).format('YYYY-MM-DD') } : {}),
                    ...(endDate ? { endDate: dayjs(endDate).format('YYYY-MM-DD') } : {})
                }
            });
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    fetchPolicyQuotation = async (quotationNumber: string): Promise<GetPolicyByQuoteNumberResponse> => {
        const url = `/api/v1/policy/by-quotation-number/${quotationNumber}`;

        try {
            const response: AxiosResponse<GetPolicyByQuoteNumberResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    canclePolicy = async (canclePolicyData: CanclePolicyRequest): Promise<CanclePolicyResponse> => {
        const url = '/api/v1/policy/cancel';
        try {
            const response: AxiosResponse<CanclePolicyResponse> = await APICallInstance.put(url, canclePolicyData);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    fetchMpesaOfflinePaymentDetails = async (quotationNumber: string): Promise<MpesaOfflinePaymentDetailsResponse> => {
        const url = `/api/v1/payment/details?quotationNumber=${quotationNumber}`;

        try {
            const response: AxiosResponse<MpesaOfflinePaymentDetailsResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    fetchMTNPaymentStatus = async (referenceId: string): Promise<GetMTNPaymentStatusResponse> => {
        const url = `api/v1/payment/mtn-status?referenceId=${referenceId}`;

        try {
            const response: AxiosResponse<GetMTNPaymentStatusResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    fetchPolicyByPolicyNo = async (policyNumber: string): Promise<GetSinglePolicyByQuoteNumberResponse> => {
        const url = `/api/v1/policy/policy-number?policyNumber=${policyNumber}`;

        try {
            const response: AxiosResponse<GetSinglePolicyByQuoteNumberResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    fetchDepedantsDetails = async (policyNumber: string): Promise<DependantsResponse> => {
        const url = `/api/v1/policy/dependants?policyNumber=${policyNumber}`;

        try {
            const response: AxiosResponse<DependantsResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    checkPolicyValidity = async (policyNumber: string) => {
        const url = `api/v1/policy/check-policy-number?policyNumber=${policyNumber}`;

        try {
            const response: AxiosResponse<CheckPolicyValidityResponse> = await APICallInstance.get(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    getAllPolicies = async (
        pageNumber: number,
        pageSize: number,
        flag: PolicyFlag,
        transactionStatus?: AimsStatus,
        searchValue?: string,
        startDate?: string,
        endDate?: string,
        agencyName?: string,
        regionName?: string
    ) => {
        const url = `/api/v1/policy`;

        try {
            const response: AxiosResponse<GetAllPoliciesResponse> = await APICallInstance.get(url, {
                params: {
                    page: pageNumber,
                    pageSize: pageSize,
                    flag: flag,
                    ...(transactionStatus !== undefined && { transactionStatus }),
                    ...(searchValue ? { searchValue } : {}), // Only add searchInput if it has a valid value
                    ...(startDate ? { startDate: dayjs(startDate).format('YYYY-MM-DD') } : {}),
                    ...(endDate ? { endDate: dayjs(endDate).format('YYYY-MM-DD') } : {}),
                    ...(agencyName !== undefined && { agencyName }),
                    ...(regionName !== undefined && regionName !== 'All' && { regionName })
                }
            });

            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
    downloadAllPolicies = async (
        pageNumber: number,
        pageSize: number,
        flag: PolicyFlag,
        transactionStatus?: AimsStatus,
        searchValue?: string,
        startDate?: string,
        endDate?: string,
        agencyName?: string,
        regionName?: string
    ) => {
        const url = `api/v1/policy/report`;

        try {
            const response: AxiosResponse<DownloadPolicyReportResponse> = await APICallInstance.get(url, {
                params: {
                    page: pageNumber,
                    pageSize: pageSize,
                    flag: flag,
                    ...(transactionStatus !== undefined && { transactionStatus }),
                    ...(searchValue ? { searchValue } : {}), // Only add searchInput if it has a valid value
                    ...(startDate ? { startDate: dayjs(startDate).format('YYYY-MM-DD') } : {}),
                    ...(endDate ? { endDate: dayjs(endDate).format('YYYY-MM-DD') } : {}),
                    ...(agencyName !== undefined && { agencyName }),
                    ...(regionName !== undefined && regionName !== 'All' && { regionName })
                }
            });

            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    pushToAims = async (quotationNumber: string) => {
        const url = `/api/v1/policy/send/aims?policyNumber=${quotationNumber}`;

        try {
            const response: AxiosResponse<PushToAmisResponse> = await APICallInstance.put(url);
            console.log(response);
            return response.data;
        } catch (error) {
            throw error;
        }
    };
}

export const PolicyService = new PolicyServiceClass();
